import { Centralizer } from '@/components';
import type { FC } from 'react';
import { useSearchParams } from 'react-router';

import { AuthenticationPagesLayout } from '../_components/AuthenticationPagesLayout';
import { InitializePasswordForm } from '../_components/InitializePasswordForm';

const keyName = 'token';

const InitializePasswordPage: FC = () => {
  const [searchParams] = useSearchParams();

  return (
    <AuthenticationPagesLayout>
      <Centralizer>
        <InitializePasswordForm token={searchParams.get(keyName) ?? ''} />
      </Centralizer>
    </AuthenticationPagesLayout>
  );
};

export default InitializePasswordPage;
